module.exports = __webpack_public_path__ + "static/movecounselors-54730e5ba6f51926851891263a1bcd64.png";